export const STYLES_BACKDROP_DARK = ({
  backgroundColor: 'rgba(0,0,0,.32)'
});
